import { PlatformClientUserFilterData } from '../types';

const initialPlatformClientUserFilterData: PlatformClientUserFilterData = {
    query: '',
    plans: [],
    isArchived: null,
    isVerified: null,
    teams: [],
};

export default initialPlatformClientUserFilterData;
